// "use client";
// import Link from "next/link";
// import Image from "next/image";
// import {
//   FaFacebookF,
//   FaInstagram,
//   FaYoutube,
//   FaCcVisa,
//   FaCcMastercard,
//   FaCcAmex,
//   FaCcPaypal,
// } from "react-icons/fa";
// import { SiTiktok } from "react-icons/si"; // TikTok icon

// const DIGITAL_OCEAN_SPACES_CDN =
//   "https://lilylanka-public-prod.sgp1.cdn.digitaloceanspaces.com";

// export default function SiteFooter() {
//   return (
//     <footer className="bg-purple-900 text-gray-100 screen-only">
//       <div className="mx-auto max-w-7xl px-4 py-12 sm:px-6 lg:px-8 grid grid-cols-2 md:grid-cols-4 gap-8">
//         {/* Company */}
//         <div>
//           <h3 className="text-white font-semibold mb-4">Company</h3>
//           <ul className="space-y-2 text-sm">
//             <li>
//               <Link href="/footer/company/aboutus" className="hover:text-white">
//                 About Us
//               </Link>
//             </li>
//             <li>
//               <Link href="/footer/company/careers" className="hover:text-white">
//                 Careers
//               </Link>
//             </li>
//             {/* <li>
//               <span className="hover:text-white">Blog</span>
//             </li> */}
//             <li>
//               <Link href="/footer/company/news" className="hover:text-white">
//                 News
//               </Link>
//             </li>
//           </ul>
//         </div>

//         {/* Policies */}
//         <div>
//           <h3 className="text-white font-semibold mb-4">Policies</h3>
//           <ul className="space-y-2 text-sm">
//             <li>
//               <Link
//                 href="/footer/policies/privacy"
//                 className="hover:text-white"
//               >
//                 Privacy & Cookie Policy
//               </Link>
//             </li>
//             <li>
//               <Link href="/footer/policies/terms" className="hover:text-white">
//                 Terms of Service
//               </Link>
//             </li>
//           </ul>
//         </div>

//         {/* Help and Support */}
//         <div>
//           <h3 className="text-white font-semibold mb-4">Help & Support</h3>
//           <ul className="space-y-2 text-sm">
//             <li>
//               <Link href="/footer/help/contact-us" className="hover:text-white">
//                 Contact Us
//               </Link>
//             </li>
//             <li>
//               <Link href="/footer/help/faq" className="hover:text-white">
//                 FAQs
//               </Link>
//             </li>
//             <li>
//               <Link
//                 href="/footer/help/support-center"
//                 className="hover:text-white"
//               >
//                 Support Center
//               </Link>
//             </li>
//           </ul>
//         </div>

//         {/* Connect with Us */}
//         <div>
//           <h3 className="text-white font-semibold mb-4">Connect with Us</h3>
//           <div className="flex flex-wrap gap-3">
//             <a
//               href="https://www.facebook.com/share/15FprWU6HPt/?mibextid=wwXIfr"
//               target="_blank"
//               rel="noopener noreferrer"
//               className="p-2 rounded-full bg-gray-800 hover:bg-purple-600 transition"
//             >
//               <FaFacebookF className="text-white w-4 h-4" />
//             </a>
//             <a
//               href="https://www.instagram.com/lily__lanka?igsh=MTdjY2V2dTQ2MXFzdg%3D%3D&utm_source=qr"
//               target="_blank"
//               rel="noopener noreferrer"
//               className="p-2 rounded-full bg-gray-800 hover:bg-purple-600 transition"
//             >
//               <FaInstagram className="text-white w-4 h-4" />
//             </a>
//             <a
//               href="https://www.tiktok.com/@lily.lanka?_t=ZS-901fAQ9f4fF&_r=1"
//               target="_blank"
//               rel="noopener noreferrer"
//               className="p-2 rounded-full bg-gray-800 hover:bg-purple-600 transition"
//             >
//               <SiTiktok className="text-white w-4 h-4" />
//             </a>
//             <a
//               href="https://www.youtube.com/@LilyLanka"
//               target="_blank"
//               rel="noopener noreferrer"
//               className="p-2 rounded-full bg-gray-800 hover:bg-purple-600 transition"
//             >
//               <FaYoutube className="text-white w-4 h-4" />
//             </a>
//           </div>

//           {/* We Accept */}
//           <h3 className="text-white font-semibold mb-4 mt-7">We Accept</h3>
//           <div className="flex flex-wrap items-center gap-3">
//             <FaCcVisa className="text-white/90 w-9 h-9" />
//             <FaCcMastercard className="text-white/90 w-9 h-9" />
//             {/* <FaCcAmex className="text-white/90 w-9 h-9" /> */}
//             {/* <FaCcAmex className="text-white/90 w-9 h-9" /> */}
//             {/* <FaCcPaypal className="text-white/90 w-9 h-9" /> */}
//           </div>
//         </div>
//       </div>

//       {/* Get the App — centered standalone section */}
//       <div className="flex flex-col items-center pb-10">
//         <h3 className="text-white font-semibold mb-3 text-center">
//           Get the App Lilylanka Mobile
//         </h3>
//         <div className="flex flex-wrap justify-center gap-6">
//           {/* App Store */}
//           <div className="flex flex-col items-center gap-2">
//             <div className="rounded-xl p-2 w-32 h-32 flex items-center justify-center">
//               <Image
//                 src={`${DIGITAL_OCEAN_SPACES_CDN}/Site/images/footer/app%20store.webp`}
//                 alt="Download on the App Store"
//                 width={120}
//                 height={120}
//                 unoptimized
//                 className="w-full h-full object-contain"
//               />
//             </div>
//             <a
//               href="https://apps.apple.com/lk/app/lily-lanka/id6760127534"
//               target="_blank"
//               rel="noopener noreferrer"
//               className="flex items-center justify-center h-10 w-32"
//             >
//               <Image
//                 src={`${DIGITAL_OCEAN_SPACES_CDN}/Site/images/footer/about%20us/apple.png`}
//                 alt="Download on the App Store"
//                 width={128}
//                 height={40}
//                 unoptimized
//                 className="h-full w-full object-contain"
//               />
//             </a>
//           </div>

//           {/* Google Play */}
//           <div className="flex flex-col items-center gap-2">
//             <div className="rounded-xl p-2 w-32 h-32 flex items-center justify-center">
//               <Image
//                 src={`${DIGITAL_OCEAN_SPACES_CDN}/Site/images/footer/play%20store.webp`}
//                 alt="Download on Google Play"
//                 width={120}
//                 height={120}
//                 unoptimized
//                 className="w-full h-full object-contain"
//               />
//             </div>
//             <a
//               href="https://play.google.com/store/apps/details?id=com.lilylanka_mobile"
//               target="_blank"
//               rel="noopener noreferrer"
//               className="flex items-center justify-center h-9 w-32"
//             >
//               <Image
//                 src={`${DIGITAL_OCEAN_SPACES_CDN}/Site/images/footer/about%20us/google.png`}
//                 alt="Get it on Google Play"
//                 width={120}
//                 height={40}
//                 unoptimized
//                 className="h-full w-full object-contain"
//               />
//             </a>
//           </div>
//         </div>
//       </div>

//       {/* Bottom copyright */}
//       <div className="border-t border-gray-700 py-4 text-center text-sm text-gray-100">
//         © {new Date().getFullYear()} LilyLanka. All rights reserved.
//       </div>
//     </footer>
//   );
// }
"use client";
import Link from "next/link";
import Image from "next/image";
import {
  FaFacebookF,
  FaInstagram,
  FaYoutube,
  FaCcVisa,
  FaCcMastercard,
} from "react-icons/fa";
import { SiTiktok } from "react-icons/si";
import { label, div, footer } from "framer-motion/client";
import { Icon } from "lucide-react";

const DIGITAL_OCEAN_SPACES_CDN =
  "https://lilylanka-public-prod.sgp1.cdn.digitaloceanspaces.com";

const LINK_COLUMNS = [
  {
    title: "Company",
    links: [
      { label: "About Us", href: "/footer/company/aboutus" },
      { label: "Careers", href: "/footer/company/careers" },
      { label: "News", href: "/footer/company/news" },
    ],
  },
  {
    title: "Policies",
    links: [
      { label: "Privacy & Cookie Policy", href: "/footer/policies/privacy" },
      { label: "Terms of Service", href: "/footer/policies/terms" },
    ],
  },
  {
    title: "Help & Support",
    links: [
      { label: "Contact Us", href: "/footer/help/contact-us" },
      { label: "FAQs", href: "/footer/help/faq" },
      { label: "Support Center", href: "/footer/help/support-center" },
    ],
  },
];

const SOCIALS = [
  {
    Icon: FaFacebookF,
    href: "https://www.facebook.com/share/15FprWU6HPt/?mibextid=wwXIfr",
    label: "Facebook",
  },
  {
    Icon: FaInstagram,
    href: "https://www.instagram.com/lily__lanka?igsh=MTdjY2V2dTQ2MXFzdg%3D%3D&utm_source=qr",
    label: "Instagram",
  },
  {
    Icon: SiTiktok,
    href: "https://www.tiktok.com/@lily.lanka?_t=ZS-901fAQ9f4fF&_r=1",
    label: "TikTok",
  },
  {
    Icon: FaYoutube,
    href: "https://www.youtube.com/@LilyLanka",
    label: "YouTube",
  },
];

export default function SiteFooter() {
  return (
    <footer className="relative bg-purple-950 text-white screen-only overflow-hidden">
      {/* Ambient glow accents */}
      <div className="pointer-events-none absolute -top-24 -left-24 h-72 w-72 rounded-full bg-purple-600/20 blur-3xl" />
      <div className="pointer-events-none absolute -bottom-24 -right-24 h-72 w-72 rounded-full bg-fuchsia-600/10 blur-3xl" />

      <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 pt-14 pb-10">
        {/* ── Top: brand + links + socials ── */}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 pb-12">
          {/* Brand blurb */}
          <div className="lg:col-span-4">
            <Image
              src={`${DIGITAL_OCEAN_SPACES_CDN}/Site/images/logo/logo_white1.png`}
              alt="LilyLanka"
              width={300}
              height={300}
              unoptimized
              className="h-40 w-auto object-contain"
            />
            <p className="mt-3 text-sm text-white-400 leading-relaxed max-w-xs">
              Your gateway to smooth, exciting, and personalized travel
              experiences across Sri Lanka.
            </p>

            <div className="mt-6 flex flex-wrap gap-3">
              {SOCIALS.map(({ Icon, href, label }) => (
                <a
                  key={label}
                  href={href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={label}
                  className="p-2.5 rounded-full bg-white/5 hover:bg-purple-600 ring-1 ring-white/10 hover:ring-purple-500 transition-all duration-200 hover:-translate-y-0.5"
                >
                  <Icon className="text-white w-4 h-4" />
                </a>
              ))}
            </div>

            <div className="mt-7">
              <p className="text-xs font-semibold uppercase tracking-wider text-white-500 mb-3">
                We Accept
              </p>
              <div className="flex items-center gap-3">
                <FaCcVisa className="text-white/70 w-8 h-8" />
                <FaCcMastercard className="text-white/70 w-8 h-8" />
              </div>
            </div>
          </div>

          {/* Link columns + Get the App, stacked in the same right-side block */}
          <div className="lg:col-span-8 flex flex-col gap-10">
            <div className="grid grid-cols-2 sm:grid-cols-3 gap-8">
              {LINK_COLUMNS.map((col) => (
                <div key={col.title}>
                  <h3 className="text-white font-semibold mb-4 text-lg">
                    {col.title}
                  </h3>
                  <ul className="space-y-2.5 text-sm">
                    {col.links.map((link) => (
                      <li key={link.label}>
                        <Link
                          href={link.href}
                          className="text-white-400 hover:text-white transition-colors"
                        >
                          {link.label}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>

            {/* Get the app */}
            <div className="grid grid-cols-2 sm:grid-cols-3 gap-8">
              <div className="sm:col-start-2">
                <h3 className="text-white font-semibold mb-4 text-lg">
                  Get the App
                </h3>
                <div className="flex gap-6">
                  {/* App Store: QR on top, badge below */}
                  <div className="flex flex-col items-center gap-2">
                    <Image
                      src={`${DIGITAL_OCEAN_SPACES_CDN}/Site/images/footer/app%20store.webp`}
                      alt="Scan to download on the App Store"
                      width={80}
                      height={80}
                      unoptimized
                      className="w-24 h-24 object-contain"
                    />

                    <a
                      href="https://apps.apple.com/lk/app/lily-lanka/id6760127534"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="flex items-center justify-center bg-white/5 hover:bg-white/10 ring-1 ring-white/10 rounded-xl px-3 py-2.5 transition-colors"
                    >
                      <Image
                        src={`${DIGITAL_OCEAN_SPACES_CDN}/Site/images/footer/about%20us/apple.png`}
                        alt="Download on the App Store"
                        width={100}
                        height={32}
                        unoptimized
                        className="h-6 w-auto object-contain"
                      />
                    </a>
                  </div>

                  {/* Google Play: QR on top, badge below */}
                  <div className="flex flex-col items-center gap-2">
                    <Image
                      src={`${DIGITAL_OCEAN_SPACES_CDN}/Site/images/footer/play%20store.webp`}
                      alt="Scan to download on Google Play"
                      width={80}
                      height={80}
                      unoptimized
                      className="w-24 h-24 object-contain"
                    />

                    <a
                      href="https://play.google.com/store/apps/details?id=com.lilylanka_mobile"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="flex items-center justify-center bg-white/5 hover:bg-white/10 ring-1 ring-white/10 rounded-xl px-3 py-2.5 transition-colors"
                    >
                      <Image
                        src={`${DIGITAL_OCEAN_SPACES_CDN}/Site/images/footer/about%20us/google.png`}
                        alt="Get it on Google Play"
                        width={100}
                        height={32}
                        unoptimized
                        className="h-6 w-auto object-contain"
                      />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* ── Divider ── */}
        <div className="h-px w-full bg-gradient-to-r from-transparent via-white/15 to-transparent" />

        {/* ── Bottom: quote + copyright + developed by ── */}
        <div className="pt-8 flex flex-col items-center text-center gap-5">
          <p className="text-sm italic text-white-400 max-w-2xl leading-relaxed">
            "Explore, relax, and create unforgettable memories with LilyLanka,
            your one-stop gateway to smooth, exciting, and personalized travel
            adventures across the world's hidden gem."
          </p>
          <p className="text-sm font-semibold text-white">
            Sri Lanka, a place like no other!
          </p>

          <div className="flex flex-col sm:flex-row items-center gap-4 sm:gap-8 mt-2">
            <p className="text-xs text-white-500">
              © {new Date().getFullYear()} LilyLanka. All rights reserved.
            </p>
            <span className="hidden sm:block h-3 w-px bg-white/15" />
            <a
              href="https://www.fossyllabs.com"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2 opacity-80 hover:opacity-100 transition-opacity"
            >
              <span className="text-xs text-white-500">Developed by</span>
              <Image
                src="/images/fossyl-labs.png"
                alt="Fossyl Labs"
                width={140}
                height={36}
                unoptimized
                className="h-6 w-auto object-contain"
              />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
